module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6EFKw"))).then(() => module.bundle.root('8rm4T'));